{
  "nl": {
    "navbar": {
      "customer": {
        "after_care": "Nazorg",
        "dashboard": "Dashboard",
        "decisions": "Beslissingen",
        "documents": "Documenten",
        "inspirations": "Inspiraties",
        "installments": "Financiën",
        "profile": "Jouw Profiel",
        "projectinfo": "Informatie",
        "question_lists": "FAQ",
        "surveys": "Enquêtes",
        "ticket": {
          "new": "Nieuw Gesprek"
        },
        "tickets": "Gesprekken",
        "units": "Postinterventiedossier"
      },
      "employee": {
        "all_projects": "Projecten",
        "client": "Profiel {client}",
        "contacts": "Contacten",
        "customer": "Klant",
        "dashboard": "Dashboard",
        "employee": "Teamlid",
        "overview": "Overzicht",
        "partner": "Partner",
        "profile": "Jouw Profiel",
        "project": {
          "after_care": "Nazorg",
          "decisions": "Beslissingen",
          "documents": "Documenten",
          "email_conversations": "Inkomende e-mails",
          "info": "Informatie",
          "installments": "Financiën",
          "milestones": "Mijlpalen",
          "news": "Nieuws",
          "question_lists": "FAQs",
          "sales": "Verkoop",
          "surveys": "Enquêtes",
          "tasks": "Taken",
          "todos": "Taken"
        },
        "projects": "Projecten",
        "ticket": {
          "new": "Nieuw Gesprek"
        },
        "tickets": "Gesprekken"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Primaire navigatie",
            "secondary": "Secundaire navigatie"
          }
        }
      },
      "partner": {
        "contacts": "Contacten",
        "dashboard": "Dashboard",
        "profile": "Jouw Profiel",
        "project": {
          "after_care": "Nazorg",
          "decisions": "Beslissingen",
          "documents": "Documenten",
          "tickets": "Gesprekken"
        },
        "projects": "Projecten"
      },
      "topnavbar": {
        "company": "Organisatie",
        "helpcenter": "Help Center",
        "inviteManageMembers": "Leden uitnodigen en beheren",
        "logout": "Afmelden",
        "profile": "Profiel",
        "searchTeam": "Zoek organisatie",
        "selectTeam": "Selecteer organisatie",
        "settings": "Instellingen",
        "team": "Team"
      }
    }
  }
}
